import { render } from "./RegraPrecoCadastro.vue?vue&type=template&id=02a9e04c&ts=true"
import script from "./RegraPrecoCadastro.vue?vue&type=script&lang=ts"
export * from "./RegraPrecoCadastro.vue?vue&type=script&lang=ts"

import exportComponent from "D:\\OnSeller\\FrontEnd\\Admin\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__